"use strict";

module.exports = require("./is-implemented")()
	? Object.setPrototypeOf
	: require("./shim");



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/set-prototype-of/index.js
// module id = 362
// module chunks = 0